// Entry point for the build script in your package.json

import Alpine from "alpinejs";
import ajax from "@imacrayon/alpine-ajax";
import tiptap from "./components/tiptap.js";

window.Alpine = Alpine;

Alpine.plugin(ajax);
Alpine.data("tiptap", tiptap);

document.querySelectorAll("form[data-confirm]").forEach((form) => {
  form.addEventListener("submit", (event) => {
    const message = form.dataset.confirm;
    if (!confirm(message)) {
      event.preventDefault();
    }
  });
});

Alpine.start();
